import { useState } from "react";
import { Card, CardBody, Col, Input } from "reactstrap";
import { toast } from "react-toastify";
import { Btn, P } from "../../../../../AbstractElements";
import CommonCardHeader from "../../../../../Utils/CommonComponents/CommonCardHeader";
import { ClipboardOnTextAreaTitle, Copy, Cut } from "../../../../../Utils/Constants";

export default function ClipboardOnTextArea() {
  const clipboardOnTextAreaText: string = "A web designer must always enhance their work since creating websites is a creative effort. Therefore, a web designer must be more imaginative to produce exceptional results. Blogs about web design assist web designers in learning about new technologies, offer lessons, news, direction for a freebie, and much more. These blogs allow web designers to stay creative and improve their abilities. Therefore, advice from web design blogs is required to improve your business.";
  const [clipBoardValues, setClipBoardValues] = useState(clipboardOnTextAreaText);
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(clipBoardValues);
      setClipBoardValues(clipBoardValues);
    } catch (err) {
      toast.error("Failed to copy text: " + err);
    }
  };

  const handleCut = async () => {
    try {
      await navigator.clipboard.writeText(clipBoardValues);
      setClipBoardValues("");
    } catch (err) {
      toast.error("Failed to cut text: " + err);
    }
  };
  return (
    <Col sm={12} md={6}>
      <Card>
        <CommonCardHeader title={ClipboardOnTextAreaTitle} />
        <CardBody>
          <div className="clipboaard-container">
            <P className="card-description mb-2">{"Cut/copy from textarea"}</P>
            <Input type="textarea" onChange={(event) => setClipBoardValues(event.target.value)} className="f-14" rows={3} value={clipBoardValues} />
            <div className="mt-3 text-end">
              <Btn className="btn-clipboard text-light me-2" color="warning" onClick={handleCopy}>
                <i className="fa-solid fa-copy" /> {Copy}
              </Btn>
              <Btn className="btn-clipboard-cut" color="success" onClick={handleCut}>
                <i className="fa-solid fa-scissors" /> {Cut}
              </Btn>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
}
